import { render, staticRenderFns } from "./lp-campaign-for-wine-lovers.vue?vue&type=template&id=baf7e1b0&scoped=true"
import script from "./lp-campaign-for-wine-lovers.vue?vue&type=script&lang=js"
export * from "./lp-campaign-for-wine-lovers.vue?vue&type=script&lang=js"
import style0 from "./lp-campaign-for-wine-lovers.vue?vue&type=style&index=0&id=baf7e1b0&prod&scoped=true&lang=css"
import style1 from "./lp-campaign-for-wine-lovers.vue?vue&type=style&index=1&id=baf7e1b0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf7e1b0",
  null
  
)

export default component.exports